<template>
  <div class="address-information-data">
    <div class="row mb-3">
      <div class="col-sm-12 col-md-4 px-0 address-type">
        <validation-provider v-slot="{ errors }" rules="required">
          <custom-drop-down
            v-model="value.addressType"
            :clearable="false"
            :custom-error-msg="validationMessages.select"
            :disabled="value.addressId != null"
            :error="errors[0]"
            fieldkey="id"
            fieldname="name"
            label="Tipo de Dirección:"
            :options="availableAddressTypes"
            placeholder="Seleccione"
          />
        </validation-provider>
      </div>
    </div>
    <div class="row mb-3">
      <div class="col-sm-12 col-md-4 px-0 col-address">
        <div class="col-sm mb-3 data">
          <validation-provider v-slot="{ errors }" rules="required">
            <custom-input
              v-model="value.addressLine1"
              :error="errors[0]"
              label="Dirección (Línea 1):"
            />
          </validation-provider>
        </div>
        <div class="col-sm mb-3 data">
          <custom-input
            v-model="value.addressLine2"
            label="Dirección (Línea 2):"
          />
        </div>
        <div class="col-sm mb-3 data">
          <custom-input
            v-model="value.addressLine3"
            label="Dirección (Línea 3):"
          />
        </div>
      </div>
      <div class="col-sm-12 col-md-8 px-0">
        <div class="col-sm-12 col-md-6 mb-3 px-0 fl col-metadata-1">
          <validation-provider v-slot="{ errors }" rules="required">
            <custom-drop-down
              v-model="value.municipality"
              :custom-error-msg="validationMessages.select"
              :error="errors[0]"
              fieldkey="id"
              fieldname="name"
              label="Municipio:"
              :options="municipalities"
              placeholder="Seleccione"
            />
          </validation-provider>
        </div>
        <div class="col-sm-12 col-md-6 mb-3 px-0 fl col-metadata-2">
          <validation-provider v-slot="{ errors }" rules="required">
            <custom-input
              v-model="value.zipCode"
              :error="errors[0]"
              label="Código Postal:"
              mask-type="ZipcodeExt"
              placeholder="_____-____"
            />
          </validation-provider>
        </div>
        <div class="clearfix" />
        <div class="col-sm-12 col-md-6 mb-3 px-0 fl col-metadata-1">
          <validation-provider
            v-slot="{ errors }"
            :rules="{ regex: /(-?\d+(\.\d+)?)/ }"
          >
            <custom-input
              v-model="value.gpsLatitude"
              :custom-error-msg="validationMessages.invalidCoordinate"
              :error="errors[0]"
              label="Latitud:"
              placeholder="____._________"
            />
          </validation-provider>
        </div>
        <div class="col-sm-12 col-md-6 mb-3 px-0 fl col-metadata-2">
          <validation-provider
            v-slot="{ errors }"
            :rules="{ regex: /(-?\d+(\.\d+)?)/ }"
          >
            <custom-input
              v-model="value.gpsLongitude"
              :custom-error-msg="validationMessages.invalidCoordinate"
              :error="errors[0]"
              label="Longitud:"
              placeholder="____._________"
            />
          </validation-provider>
        </div>
        <div class="col-sm-12 mb-3 fl col-metadata-1 pr-0">
          <custom-input
            v-model="value.addressDescription"
            label="Anotaciones Adicionales:"
            placeholder="Escribir información adicional de cómo llegar…"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CustomDropDown from 'custom-drop-down';
import CustomInput from 'CustomInput';
import { getMunicipalities as _getMunicipalities } from '@/modules/common/location.api';
import { getAddressTypes as _getAddressTypes } from '@/modules/provider/api';

export default {
  name: 'AddressInformation',
  components: {
    CustomInput,
    CustomDropDown,
  },
  props: {
    value: {
      type: Object,
      default: () => ({
        addressId: null,
        addressLine1: null,
        addressLine2: null,
        addressLine3: null,
        zipCode: null,
        addressTypeCd: null,
        municipalityId: null,
        gpsLatitude: null,
        gpsLongitude: null,
        addressDescription: null,
      }),
    },
    validationGroup: {
      type: String,
      default: 'vgAddressInformation',
    },
    addressTypes: {
      type: Array,
      default: () => [],
    },
    fiscalYearId: {
      type: Number,
      default: () => null,
    },
  },
  data() {
    return {
      validationMessages: {
        required: 'Campo Requerido',
        invalidCoordinate: 'Coordenada inválida',
        select: 'Favor Seleccione',
      },
      municipalities: [],
      availableAddressTypes: this.addressTypes,
    };
  },
  watch: {
    'value.addressType'(newValue) {
      this.value.addressTypeCd = newValue.id;
      this.value.addressTypeName = newValue.name;
    },
    'value.municipality'(newValue) {
      this.value.municipalityId = newValue.id;
      this.value.municipalityName = newValue.name;
    },
  },
  async created() {
    await _getMunicipalities({
      AcademicYearId: this.fiscalYearId,
    }).then((response) => {
      this.municipalities = response;
    });

    if (this.addressTypes.length == 0) {
      await _getAddressTypes().then((response) => {
        this.addressTypes.push.apply(this.addressTypes, response.data);
      });
    }
  },
};
</script>
<style scoped lang="scss">
@media (min-width: 576px) {
  .address-information-data .col-address .data,
  .address-information-data .address-type {
    padding: 0;
  }
}

@media (min-width: 768px) {
  .address-information-data .col-address {
    float: left !important;
  }

  .address-information-data .col-address > div {
    padding-left: 0 !important;
  }

  .address-information-data .col-address .data,
  .address-information-data .address-type {
    padding-right: 20px !important;
  }

  .address-information-data .col-metadata-1 {
    float: left !important;
    padding-left: 10px !important;
    padding-right: 10px !important;
  }

  .address-information-data .col-metadata-1:last-child {
    padding-right: 0px !important;
  }

  .address-information-data .col-metadata-2 {
    float: left !important;
    padding-left: 20px !important;
    padding-right: 0px;
  }
}

::v-deep .student-search-alert-error {
  position: absolute !important;
  bottom: -22px;
}
</style>
